import React from "react";
import ProductFirstApp from "./ProductFirstApp";
import {
  Wheat, Bean, Flame, Cookie, Milk, Apple, Carrot, Droplets, Sparkles, Flower,
} from "lucide-react";

const CHIPS = [
  { id: "grains",     label: "Grains",       query: "rice",       icon: Wheat,    color: "#78350f", bg: "#fef3c7" },
  { id: "dals",       label: "Dals",         query: "dal",        icon: Bean,     color: "#78350f", bg: "#fde68a" },
  { id: "spices",     label: "Spices",       query: "spice",      icon: Flame,    color: "#7f1d1d", bg: "#fecaca" },
  { id: "atta",       label: "Atta & Flour", query: "atta",       icon: Cookie,   color: "#78350f", bg: "#fed7aa" },
  { id: "dairy",      label: "Dairy",        query: "ghee",       icon: Milk,     color: "#1e3a8a", bg: "#bfdbfe" },
  { id: "fruits",     label: "Fruits",       query: "fruit",      icon: Apple,    color: "#7f1d1d", bg: "#fecdd3" },
  { id: "vegetables", label: "Vegetables",   query: "vegetable",  icon: Carrot,   color: "#7c2d12", bg: "#fed7aa" },
  { id: "oils",       label: "Oils",         query: "oil",        icon: Droplets, color: "#a16207", bg: "#fef3c7" },
  { id: "snacks",     label: "Snacks",       query: "snack",      icon: Sparkles, color: "#831843", bg: "#f9a8d4" },
  { id: "puja",       label: "Puja Items",   query: "puja",       icon: Flower,   color: "#7c2d12", bg: "#fed7aa" },
];

export default function SabKuchFresh() {
  return (
    <ProductFirstApp
      appId="sabkuchfresh"
      theme={{ primary: "#16a34a", accent: "#65a30d" }}
      hero={{
        background: "linear-gradient(135deg,#14532d 0%, #16a34a 40%, #84cc16 100%)",
        overlay: "linear-gradient(135deg, rgba(8,30,15,0.4), rgba(8,30,15,0.05))",
        badge: "Sab Kuch Fresh · Local fresh produce, delivered quick",
        searchPlaceholder: "Search: organic vegetables, mangoes, milk, atta…",
      }}
      chips={CHIPS}
    />
  );
}
